
import { useLanguage } from "@/contexts/LanguageContext";
import { Star, Users, TrendingUp } from "lucide-react";
import { motion } from "framer-motion";

export const BookingPageHeader = () => {
  const { t, language } = useLanguage();

  return (
    <motion.div 
      className="text-center mb-10 sm:mb-16"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="relative">
        <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 sm:px-6 sm:py-3 rounded-full text-xs sm:text-sm font-semibold mb-5 sm:mb-8">
          <Star className="w-4 h-4 sm:w-5 sm:h-5" />
          {language === 'ar' ? 'شبكة المؤثرين المتميزة' : 'Premium Influencer Network'}
        </div>
        
        <h1 className="text-[clamp(1.9rem,8vw,3rem)] md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-8 bg-gradient-to-r from-primary via-secondary to-primary bg-clip-text text-transparent leading-[1.1] py-1 text-balance">
          {t('bookInfluencerTitle')}
        </h1>
        
        <p className="text-base sm:text-xl md:text-2xl text-muted-foreground max-w-4xl mx-auto mb-6 sm:mb-8 leading-relaxed text-balance">
          {t('bookInfluencerDesc')}
        </p>

        {/* Quick Stats */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-8 mt-6 sm:mt-12">
          <div className="flex items-center gap-2 bg-card/50 backdrop-blur-sm border border-primary/10 rounded-full px-3 py-2 sm:px-6 sm:py-3">
            <Users className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
            <span className="text-sm sm:text-base font-semibold whitespace-nowrap">N/A {language === 'ar' ? 'مؤثر' : 'Influencers'}</span>
          </div>
          <div className="flex items-center gap-2 bg-card/50 backdrop-blur-sm border border-primary/10 rounded-full px-3 py-2 sm:px-6 sm:py-3">
            <TrendingUp className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
            <span className="text-sm sm:text-base font-semibold whitespace-nowrap">N/A {language === 'ar' ? 'متابع' : 'Followers'}</span>
          </div>
          <div className="flex items-center gap-2 bg-card/50 backdrop-blur-sm border border-primary/10 rounded-full px-3 py-2 sm:px-6 sm:py-3">
            <Star className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
            <span className="text-sm sm:text-base font-semibold whitespace-nowrap">N/A {language === 'ar' ? 'تقييم' : 'Rating'}</span>
          </div>
        </div>
      </div>
    </motion.div>

  );
};
